import {createSlice} from '@reduxjs/toolkit';

const initialState: null | {
    id: null | number;
    name: null | string;
    sumServices: null | number;
    sumActives: null | number;
    loaded: true | false;
} = {
    id: null,
    name: null,
    sumServices: null,
    sumActives: null,
    loaded: false,
};

const funnelUserSlice = createSlice({
    name: 'funnelUser',
    initialState,
    reducers: {
        setFunnelUser(state, action) {
            return {
                ...state,
                ...action.payload,
            };        },
        clearFunnelUser() {
            return initialState;
        },
    },
});

export const { setFunnelUser, clearFunnelUser } = funnelUserSlice.actions;

export default funnelUserSlice.reducer;